export type StreamType = "direct" | "hls" | "playlist" | "unsupported";

export function streamType(url: string): StreamType {
  const lower = url.toLowerCase();
  if (/^(mms|rtmp|rtsp):/.test(lower)) return "unsupported";

  const path = lower.split(/[?#]/)[0];
  if (path.endsWith(".m3u8")) return "hls";
  if (path.endsWith(".mpd") || path.endsWith(".asx") || path.endsWith(".wax")) return "unsupported";
  if (path.endsWith(".pls") || path.endsWith(".m3u")) return "playlist";
  return "direct";
}

// Returns the first stream URL listed in a .pls or .m3u playlist.
export async function resolvePlaylist(url: string, signal: AbortSignal): Promise<string> {
  const response = await fetch(url, { signal });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const text = await response.text();

  for (const raw of text.split(/\r?\n/)) {
    const line = raw.trim();
    const plsEntry = line.match(/^File\d+=(.+)$/i);
    if (plsEntry) return plsEntry[1].trim();
    if (/^https?:\/\//i.test(line)) return line;
  }
  throw new Error("No stream found in playlist");
}

export function isBlockedMixedContent(url: string): boolean {
  return window.location.protocol === "https:" && url.toLowerCase().startsWith("http:");
}
